<script>
  import { fade } from "svelte/transition";
  import { flip } from "svelte/animate";

  import WarningIcon from "@local/assets/icons/warning.svg";
  import InfoIcon from "@local/assets/icons/info.svg";
  import XIcon from "@local/assets/icons/x.svg";
  import CheckIcon from "@local/assets/icons/check.svg";

  import { alerts } from "#src/stores/alerts";

  const icons = {
    info: InfoIcon,
    warning: WarningIcon,
    danger: WarningIcon,
    error: WarningIcon,
    ok: CheckIcon,
  };

  const colors = {
    info: "oklch(76.8% 0.233 130.85)",
    warning: "oklch(79.5% 0.184 86.047)",
    danger: "oklch(70.4% 0.191 22.216)",
    error: "oklch(70.4% 0.191 22.216)",
    ok: "oklch(70.7% 0.165 254.624)",
  };

  function deleteAlert(id) {
    alerts.remove(id);
  }
</script>

<div
  class="absolute w-full h-full pointer-events-none z-50 flex flex-col items-center space-y-2 pt-28 text-sm">
  {#each $alerts as alert (alert.id)}
    <div
      class="px-4 py-2 rounded flex gap-2 items-center"
      in:fade={{ duration: 300 }}
      out:fade={{ duration: 300 }}
      animate:flip={{ duration: 300 }}
      style={`background-color: ${colors[alert.type]}; color: white;`}>
      <div>
        <svelte:component this={icons[alert.type]} />
      </div>
      <div>
        {alert.message}
      </div>
      <button class="ml-4 pointer-events-auto" on:click={() => deleteAlert(alert.id)}>
        <XIcon />
      </button>
    </div>
  {/each}
</div>
